import React, {Component, Suspense} from 'react';
import {connect} from 'react-redux';
import {Switch} from 'react-router-dom';
import config from 'config';
import routeList, {routes} from '../../routes';
import FeedbackDrawer from 'components/general/feedbackDrawer/FeedbackDrawer';
import Main from 'components/layouts/Main';
import Loader from 'components/utils/loader/Loader';
import './App.scss';
import {applyCustomStyles, defaultIfBlank} from '../../utils';
import TagManager from 'react-gtm-module/dist/TagManager';
import LanguageSelector from '../general/languageSelector/LanguageSelector';
import Start from "../views/start/Start";
import queryString from 'query-string';

/**
 * App component
 */
class App extends Component {



  componentDidMount() {

    if (defaultIfBlank(config.gtm.gtmId)) {
      TagManager.initialize({
        gtmId: config.gtm.gtmId
      });
    }
    applyCustomStyles();
  }

  render() {
    const params = queryString.parse(window.location.search);
    const conf = Start.getMainUiConfigFromParams(params);
    console.log(conf)
    return (
      <div>
        <div className='App'>
          <Main>
            {conf.showLangSelector &&
            <div className="language-selector-wrapper">
              <LanguageSelector/>
            </div>}
            <Suspense fallback={<Loader/>}>
              <Switch>
                {routes(routeList)}
              </Switch>
            </Suspense>
          </Main>
        </div>
        <FeedbackDrawer/>
      </div>
    );
  }
}

export default connect()(App);
